module.exports = __webpack_public_path__ + "media/application/images/svgs/layout-31da00fa6059585f942eed3f9a80d818.svg";